import { useState, useMemo } from 'react';
import { Wand2, Sparkles, Scale, BookText } from 'lucide-react';

interface StyleIndicatorProps {
  currentTemplate: string;
  onTemplateChange: (templateName: string) => void;
}

type TemplateKey =
  | 'lovable_gpt'
  | 'conversational'
  | 'formal_legal'
  | 'technical'
  | 'creative'
  | 'abnt_juridico';

const OPTIONS: Array<{ key: TemplateKey; label: string; icon: any }> = [
  { key: 'lovable_gpt',   label: 'Padrão Laib', icon: Sparkles },
  { key: 'conversational',label: 'Conversacional',        icon: Wand2   },
  { key: 'formal_legal',  label: 'Formal Jurídico',       icon: Scale  },
  { key: 'technical',     label: 'Técnico',               icon: BookText},
  { key: 'creative',      label: 'Criativo',              icon: Sparkles},
  { key: 'abnt_juridico', label: 'ABNT Jurídico',         icon: BookText},
];

export function StyleIndicator({ currentTemplate, onTemplateChange }: StyleIndicatorProps) {
  const [open, setOpen] = useState(false);

  const current: TemplateKey = useMemo(() => {
    return (
      (currentTemplate as TemplateKey) ||
      'lovable_gpt'
    );
  }, [currentTemplate]);

  const CurrentIcon = useMemo(
    () => OPTIONS.find(o => o.key === current)?.icon ?? Sparkles,
    [current]
  );

  const handleChange = async (key: TemplateKey) => {
    await onTemplateChange(key);
    setOpen(false);
  };

  return (
    <div className="cg-style-indicator">
      <button
        type="button"
        className="cg-btn"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
        aria-label="Abrir seletor de estilo do chat"
      >
        <CurrentIcon className="cg-icon" />
        <span className="cg-label">
          {
            OPTIONS.find(o => o.key === current)?.label ??
            'Padrão Laib'
          }
        </span>
      </button>

      {open && (
        <div className="cg-popover">
          {OPTIONS.map(opt => {
            const Icon = opt.icon;
            const active = opt.key === current;
            return (
              <button
                key={opt.key}
                type="button"
                className={`cg-popover-item ${active ? 'is-active' : ''}`}
                onClick={() => handleChange(opt.key)}
              >
                <Icon className="cg-icon" />
                <span>{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
